import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TEXT,
  attribute: 'overview_url',
  label: {
    default: 'Overview Url',
    short: 'Overview Url',
  },
});
